import { render, staticRenderFns } from "./PayrollMonthlyAttendance.vue?vue&type=template&id=fa58dd00&scoped=true"
import script from "./PayrollMonthlyAttendance.vue?vue&type=script&lang=js"
export * from "./PayrollMonthlyAttendance.vue?vue&type=script&lang=js"
import style0 from "./PayrollMonthlyAttendance.vue?vue&type=style&index=0&id=fa58dd00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa58dd00",
  null
  
)

export default component.exports